<template>
  <nav id="main-nav" class="collapse d-lg-block navbar-collapse">
    <div class="navbar navbar-expand-lg flex-column align-items-stretch align-items-lg-center">
      <NavbarContent />
    </div>
  </nav>
</template>

<script>
import NavbarContent from "@/esf_antarctica_lederhosenland/core/components/header/NavbarContent.vue";
import { Logger } from "@storefront/core/lib/logger";

export default {
  name: "Navbar",
  components: {
    NavbarContent,
  },
  data: () => ({}),
  computed: {
    navExpanded: {
      get() {
        return this.$store.getters["menu/getNavbar"];
      },
      set(val) {
        Logger.debug("navExpanded set called", "Navbar", val)();
      },
    },
  },

  mounted() {
    window.addEventListener("resize", this.resize);
  },
  destroyed() {
    window.removeEventListener("resize", this.resize);
  },
  methods: {
    onClick() {},
    toggleNav() {
      this.$store.dispatch("menu/toggleNavbar");
    },
    resize() {
      document.body.classList.add("resize-active");
      if (window.innerWidth > 991) this.navExpanded = false;
      clearTimeout(this.resizeTimer);
      this.resizeTimer();
    },
    resizeTimer() {
      setTimeout(() => {
        document.body.classList.remove("resize-active");
      }, 400);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
